import React, { Fragment, useEffect, useMemo, useState } from "react";
import { formatCurrency } from "../../config/global";
import { useAppSelector } from "../../core/feature/hooks";
import TabsMobile from "../__template/TabsMobileComponent";
import dotBalance from "../../assets/images/icon_home/dot-balance.svg";
import {
  getDonationById,
  paymentDonation,
} from "../../core/service/api_donation";
import { useLocation, useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";
import User from "../../core/models/user";
import { toast } from "react-toastify";
import donation from "../../assets/images/icon_donation/donation.svg";
import filter from "../../assets/images/icon_attendance/filter.svg";

import moment from "moment";
import { getBalance } from "../../core/service/api_balance";
import { useDispatch } from "react-redux";
import { removeUser } from "../../core/feature/user/userSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { setLoading } from "../../core/feature/config/configSlice";
import { useTranslation } from "react-i18next";
import CustomApp from "../../core/models/customApp";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { isDarkColor } from "../../config/DarkColorChecker";
import { Dialog, Transition } from "@headlessui/react";

const ComponentDonationDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");

  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const getBalanceMemo = useMemo(() => formatCurrency(balance), [balance]);
  const [data, setData] = useState<any>({});
  const [historyDonation, setHistoryDonation] = useState<any>([]);
  const [show, setShow] = useState(false);

  let location: any = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [amount, setAmount] = useState("");
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();
  let [isOpen, setIsOpen] = useState(false);
  const addDonation = async () => {
    if (isNaN(parseInt(amount))) {
      return toast.warning(t("DONATION-DETAIL.isNotEmpty"));
    }
    if (balance < parseInt(amount))
      return toast.warning(t("INVOICE.balanceEmpty") + formatCurrency(balance));

    var query = {
      accountId: user.accounts[0].id,
      callerId: "",
      amount: parseInt(amount),
      cash: true,
      channel: "MOBILE",
      donationId: data.id,
    };
    console.log(query);

    dispatch(setLoading(true));
    paymentDonation(query)
      .then((res: any) => {
        dispatch(setLoading(false));
        toast.success(t("DONATION-DETAIL.success"));
        setAmount("");
        gaEventTracker("Click Donation", "Payment Donation Success");
        getDonationHistory();
        console.log("sebelum getbalance");
        getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
            navigate(-1);
          })
          .catch((err) => {
            dispatch(setLoading(false));
          });
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const openAction = async () => {
    setIsOpen(true);
  };
  const closeAction = async () => {
    setIsOpen(false);
  };

  const getDonationHistory = async () => {
    getDonationById(data.id).then((res: any) => {
      if (res.data.participants) {
        setHistoryDonation(res.data.participants.reverse());
      }
    });
  };
  const showHistory = async () => {
    if (show) {
      setShow(false);
    } else {
      setShow(true);
    }
  };
  useEffect(() => {
    setData(JSON.parse(location.state.data));
  }, []);
  useEffect(() => {
    if (data.id) {
      getDonationHistory();
    }
  }, [data]);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 bg-white`}>
        <TabsMobile
          name={`${t("DONATION-DETAIL.title")}`}
          backUrl={"donation"}
        ></TabsMobile>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeAction}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("PROFILE.confirm")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("DONATION-DETAIL.donationConfirm") +
                        " " +
                        data.title +
                        "?"}
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2 justify-center">
                    <button
                      type="button"
                      className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => closeAction()}
                    >
                      {t("OTHER.no")}
                    </button>
                    <button
                      type="button"
                      className="active:bg-psp-hover active:text-white inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={() => addDonation()}
                    >
                      {t("OTHER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      <section className="p-6 top-to-bottom">
        <div className="rounded-2xl w-full bg-white flex flex-row p-3 justify-between">
          <div className="flex flex-col gap-2">
            <h1 className="font-montserrat m-0 text-xs font-medium text-black">
              {t("DONATION-DETAIL.balance")}
            </h1>
            <p className="font-montserrat m-0 text-xl font-bold text-black">
              {getBalanceMemo}
            </p>
          </div>
          <img src={dotBalance} alt="" />
        </div>

        <div className="flex flex-col mt-4 gap-3">
          <div className="grid grid-cols-3">
            <h1 className="m-0 font-medium text-sm font-montserrat">
              {t("DONATION-DETAIL.donationName")}:
            </h1>
            <h1 className="m-0 col-span-2 font-medium text-sm font-montserrat">
              {data.title}
            </h1>
          </div>
          <h1 className="m-0 font-medium text-sm font-montserrat">
            {t("DONATION-DETAIL.input")}
          </h1>
          <CurrencyInput
            className="px-3 rounded-lg h-10 border-1 border-psp-border-gray border-solid active:border-0"
            placeholder="Rp.0"
            decimalsLimit={2}
            prefix={"Rp "}
            onValueChange={(value, name) => {
              setAmount(value || "");
              value == undefined ? setIsActive(true) : setIsActive(false);
              console.log(value);
            }}
          />
          <button
            onClick={() => openAction()}
            style={{ backgroundColor: customApp?.app_accent_color }}
            className={`rounded-lg py-2.5 font-medium font-montserrat text-sm active:bg-yellow-active ${
              isDarkColor(customApp.app_accent_color)
                ? "text-white"
                : "text-black"
            }`}
          >
            {t("DONATION-DETAIL.donationBtn")}
          </button>
        </div>

        <div className="mt-4">
          <div className="flex flex-row justify-between w-full items-center mb-3">
            <h1 className="m-0 font-montserrat text-sm font-medium ">
              {t("DONATION-DETAIL.history")}
            </h1>
            <img
              src={filter}
              className="w-6 h-6"
              onClick={() => showHistory()}
            />
          </div>
          <div className="flex flex-col gap-3" hidden={!show}>
            {historyDonation.map((res: any) => (
              <div className="bg-white p-3 rounded-xl flex-row flex gap-3 items-center shadow-md shadow-slate-200">
                <img src={donation} className="flex-0 w-9 h-9 rounded-full" />
                <div className="flex flex-col gap-1.5 grow">
                  <div className="flex flex-row items-center w-full ">
                    <h1 className="m-0 grow font-montserrat text-xs font-medium text-psp-nav">
                      {data.title}
                    </h1>
                    <h1 className="m-0 flex-0 font-montserrat text-xs  font-medium text-psp-nav">
                      {formatCurrency(res.amount)}
                    </h1>
                  </div>
                  <span
                    style={{ fontSize: 9 }}
                    className="font-montserrat  font-medium text-psp-gray"
                  >
                    {moment(res.dateTime).format("LL")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComponentDonationDetail;
